import Component from "~/route-containers/offer/offer.container";
import { offerLoader } from "~/loaders/offer.loader";
import { V2_MetaFunction } from "@remix-run/node";

export const meta: V2_MetaFunction = () => {
  return [
    { name: "charset", content: "utf-8" },
    { title: "Oferta" },
    {
      name: "viewport",
      content: "width=device-width,initial-scale=1,maximum-scale=1",
    },
    { name: "og:title", content: "Oferta" },
  ];
};

export { offerLoader as loader };

export default Component;
